import { CommitmentClassTabProps } from "features/commitment-classes/setup/CommitmentClassTabProps";
import { useInvestorClassRetrieveSuspense } from "gen/endpoints/investor-class/investor-class";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import PageContent from "shared/components/layout/PageContent";
import { PageHeader } from "shared/components/layout/PageHeader";
import { PageTabs } from "shared/components/layout/PageTabs";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";
import { rootRoute } from "shared/navigation/Routes";

export const CommitmentClassSetupPage: React.FC = () => {
  const { t } = useTranslation(["commitmentClass", "common"]);
  const navigate = useNavigate();

  const { fundFamilyId, investorClassId } = useRequiredStringParams();

  const { data: investorClassData } = useInvestorClassRetrieveSuspense(
    fundFamilyId,
    investorClassId,
  );

  const familyRoute = rootRoute({})
    .fundFamilies({})
    .fundFamily({ fundFamilyId });
  const classesRoute = familyRoute.setup({}).classes({});

  const onCancel = useCallback(() => {
    navigate(classesRoute.$);
  }, [classesRoute, navigate]);

  const tabProps: CommitmentClassTabProps = {
    fundFamilyId,
    investorClassId,
    onCancel,
  };

  return (
    <PageContent>
      <PageHeader
        title={investorClassData.name}
        backButton={{
          title: t("commitmentClass:allClasses"),
          path: classesRoute.$,
        }}
      />
      <PageTabs context={tabProps} />
    </PageContent>
  );
};
